import { EmbedPlaylist } from '../../../../../../libs/index';
import withValidation from '../../../../../../libs/lead-capture-form/utils/withValidation';

const EmbedPage = () => {
  return <EmbedPlaylist hasInteractivityTools={true} />;
};

export default withValidation(EmbedPage);
